/* eslint-disable id-length */
/* eslint-disable babel/camelcase */
/* eslint-disable babel/no-invalid-this */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */

/*
 * Search fixes (House of Cards, Oct 2026):
 *  1. Results keep Shopify's relevance order (matches were being prepended, reversing them).
 *  2. "Show More Results" links no longer wrap the query in * and are URL-encoded.
 *  3. Clicking outside the search box closes the dropdown without wiping the typed text.
 *  4. Only the latest request may update the dropdown (no stale results when typing fast).
 *  5. Every product row uses the same, valid markup (removed a stray </div>).
 *  6. The floating search's "click outside to close" handler is registered once, not on every open.
 */

class PredictiveSearchStore {
  constructor() {
    this.showPrices = true;
    this.showPriceRange = true;
    this.initialized = false;
    this.getStoreValues();
  }

  getStoreValues() {
    const predictiveSearchData = document.getElementById('predictiveSearch-js');

    if (this.initialized || !predictiveSearchData) {
      return {
        showPrices: this.showPrices,
        showPriceRange: this.showPriceRange,
      };
    }
    const showPriceRangeString = predictiveSearchData.getAttribute('data-show-price-range');
    this.showPriceRange = (showPriceRangeString !== 'false');

    const showPricesString = predictiveSearchData.getAttribute('data-show-prices');
    this.showPrices = (showPricesString !== 'false');

    this.initialized = true;

    return {
      showPrices: this.showPrices,
      showPriceRange: this.showPriceRange,
    };
  }
}

(function() {
  let globalTimeout = null;
  // Fix 4: every request gets a number; only the newest one may draw results.
  let latestRequestId = 0;

  const predictiveSearchStore = new PredictiveSearchStore();

  $('.sd_pro-search').click(() => {
    const value = $(".sd_pro-search").val();
    if (value === "") {
      $('.sd_dropdown').show();
      $('.sd_dropdown').html('');
    } else {
      $('.sd_dropdown').show();
    }
  });

  // Fix 3: close the dropdown on an outside click, but keep what the customer typed.
  $(document).on('mouseup', 'body', (event) => {
    const container = $(".sd_product-search");
    const submit = $(".searchBar__submit");
    const icon = $(".fa-search");

    if (!container.is(event.target) && container.has(event.target).length === 0 && (!submit.is(event.target)) && (!icon.is(event.target))) {
      $('.sd_dropdown').hide();
    }
  });

  $("<div class='sd_fixsearch' style='font-family: arial;border-radius: 2px 0 0 2px;box-sizing: border-box;height: 38px;max-width: 400px;position:fixed;top: 150px;z-index: 9999999999;width: 100%;transition: all 0.6s ease-in 0s;visibility:hidden;opacity:0;'><div class='sd_fixinner' style='font-family: arial;'><img alt='Search Icon' loading='lazy' src='https://storage.googleapis.com/binderpos-libraries/white-search.png' class='sd_searchicon' style='font-family: arial;cursor:pointer;background:#494c50 none repeat scroll 0 0;width: 38px; border-radius: 5px 0 0 5px;padding: 5px;float: left;'><div class='sd_product-search' style='float: left;height: 38px;position: relative;transition: all 0.5s ease 0s;max-width: auto;margin-top:0;'><input type='text' class='sd_pro-search' style='background:white!important;height: 38px!important;width:90%!important;padding: 5px!important;z-index:9999999999;'><div class='sd_dropdown'></div></div></div></div><input type='hidden' class='fullval'>").insertAfter("body");

  if ($(window).width() < 767) {
    $('.sd_fixinner .sd_product-search').css({margin: '0', 'max-width': '100%', 'font-family': 'arial', height: '38px', width: '88%', position: 'relative'});
    $('.sd_fixsearch').css({right: '-362px'});
  } else {
    $('.sd_fixinner .sd_product-search').css({margin: '0', 'max-width': '100%', 'font-family': 'arial', height: '38px', width: '90%', position: 'relative'});
    $('.sd_fixsearch').css({right: '-362px'});
  }

  let sizeee = "-362px";

  if ($(window).width() == 375) {
    $('.sd_fixsearch').css({right: '-337px'});
    sizeee = "-337px";
  }

  if ($(window).width() == 360) {
    $('.sd_fixsearch').css({right: '-322px'});
    sizeee = "-322px";
  }

  if ($(window).width() == 320) {
    $('.sd_fixsearch').css({right: '-282px'});
    sizeee = "-282px";
  }

  const searchtext = null;
  const prccolor = null;

  function titleMatchesSearch(title, search) {
    return title.toLowerCase().includes(search.toLowerCase());
  }

  function highlightMatchingTitle(title, search) {
    const matchStart = title.toLowerCase().indexOf(`${String(search.toLowerCase())}`);
    if (matchStart < 0) {
      return title;
    }

    const matchEnd = matchStart + search.length - 1;
    const beforeMatch = title.slice(0, matchStart);
    const matchText = title.slice(matchStart, matchEnd + 1);
    const afterMatch = title.slice(matchEnd + 1);

    return `${beforeMatch}<span style='color:${searchtext}!important; font-weight:700!important;'>${matchText}</span>${afterMatch}`;
  }

  function highlightList(selector, string) {
    $(selector).each(function() {
      const titleEl = $(this).find('.sd_title');
      const text = titleEl.text();
      const matchStart = text.toLowerCase().indexOf(String(string.toLowerCase()));
      if (matchStart < 0) {
        return;
      }
      const matchEnd = matchStart + string.length - 1;
      const finalMatch = `${text.slice(0, matchStart)}<span style='color:${searchtext}!important; font-weight:700!important;'>${text.slice(matchStart, matchEnd + 1)}</span>${text.slice(matchEnd + 1)}`;
      titleEl.html(finalMatch);
    });
  }

  function colHighlight(string) {
    highlightList(".sd_dropdownresult_collection li, .sd_dropdown_default li", string);
  }

  function pageHighlight(string) {
    highlightList(".sd_dropdownresult_page li, .sd_dropdown_default li", string);
  }

  // Fix 6: register the floating search's "close on outside click" once.
  function closeFixedSearch() {
    $('.sd_fixsearch').css({right: sizeee});
    $('.sd_fixsearch').removeClass('sd_fixactive');
    $('.sd_dropdown').empty();
  }

  $(document).on("click", ".sd_searchicon", () => {
    $('.sd_fixsearch').toggleClass('sd_fixactive');
    if ($('.sd_fixsearch').hasClass('sd_fixactive')) {
      $('.sd_fixsearch').css('right', '-2px');
    } else {
      closeFixedSearch();
    }
  });

  $(document).on("click", "body", (event) => {
    if (!$('.sd_fixsearch').hasClass('sd_fixactive')) {
      return;
    }
    if ($(event.target).closest('.sd_fixsearch').length > 0) {
      return;
    }
    closeFixedSearch();
  });

  $('.sd_product-search').css('display', 'none');
  $('.sd_pro-search').attr("placeholder", "Search..");


  /* Default search starts here */
  const resvalue = {defaultwidth: null, product_tab: null, collection_tab: null, page_tab: null, article_tab: null, stock_res: null, foot_text: null, footer_noresult: null};
  const defull = $.trim(resvalue.defaultwidth);
  const product = window.theme.searchMode.includes("product") ? "yes" : "no";
  const collection = 'no';
  const page = window.theme.searchMode.includes("page") ? "yes" : "no";
  const article = window.theme.searchMode.includes("article") ? "yes" : "no";
  const footer_text = $.trim(resvalue.foot_text);

  let footer_noresult = $.trim(resvalue.footer_noresult);

  if (footer_noresult == '' || footer_noresult == null) {
    footer_noresult = "No Results Found";
  }

  let footer_boxtext = footer_text;
  if (footer_text == '' || footer_text == null) {
    footer_boxtext = "Show More Results";
  }

  let out_stock = "last";
  if (resvalue.stock_res != null) {
    out_stock = $.trim(resvalue.stock_res);
  }

  const noResultHtml = `<div class="sd_more_result"><span class="sd_show_all noresult">${footer_noresult}</span></div>`;

  // Fix 2: a plain, properly encoded search link (no * wildcards).
  function searchUrl(term, type) {
    return `/search?q=${encodeURIComponent(term)}&type=${type}`;
  }

  function calculatePriceDisplay(productSuggest) {
    const {price_min, price_max, price} = productSuggest;

    const {
      showPrices,
      showPriceRange,
    } = predictiveSearchStore.getStoreValues();

    if (showPrices === false) {
      return '';
    }

    if (showPriceRange === false || price_min === price_max || price === '0.00') {
      return Shopify.formatMoney((price_max), window.theme.moneyWithCurrencyFormat);
    }
    if (price_min !== price_max) {
      return `${Shopify.formatMoney((price_min), window.theme.moneyWithCurrencyFormat)} - ${Shopify.formatMoney((price_max), window.theme.moneyWithCurrencyFormat)}`;
    }
    return Shopify.formatMoney((price), window.theme.moneyWithCurrencyFormat);
  }

  function setActiveTab(tabClass) {
    ['tablinks1', 'tablinks2', 'tablinks3', 'tablinks4'].forEach((name) => {
      $(`.${name}`).toggleClass('active', name === tabClass);
    });
  }

  // searchQuery is what Shopify searches (may include a product_type filter);
  // searchTerm is what the customer typed, used for highlighting and the "Show More" link.
  function handleFetchSearch(searchQuery, searchTerm) {
    globalTimeout = null;

    const requestId = ++latestRequestId;
    const searchstring = searchTerm.toUpperCase();
    const hostname = window.location.hostname;
    let proarray = null;

    jQuery.getJSON("/search/suggest.json", {
      q: searchQuery,
      resources: {
        type: "product,page,article,collection",
        options: {
          unavailable_products: out_stock,
          fields: "title,variants.title,product_type",
        },
      },
    }).done((response) => {
      // Fix 4: ignore responses for anything but the newest request.
      if (requestId !== latestRequestId) {
        return;
      }

      if (product == '' && collection == '' && page == '' && article == '') {
        $('.sd_dropdown').html('<div class="sd_tab"><button class="tablinks1">Products</button><button class="tablinks2">Collection</button><button class="tablinks3">Pages</button><button class="tablinks4">Articles</button></div><div class="sd_tabs"></div>');
      } else {
        let tab_html = '<div class="sd_tab">';
        if (product == 'yes' || product == '') {
          tab_html += '<button class="tablinks1">Products</button>';
        }
        if (collection == 'yes' || collection == '') {
          tab_html += '<button class="tablinks2">Collection</button>';
        }
        if (page == 'yes' || page == '') {
          tab_html += '<button class="tablinks3">Pages</button>';
        }
        if (article == 'yes' || article == '') {
          tab_html += '<button class="tablinks4">Articles</button>';
        }
        tab_html += '</div><div class="sd_tabs"></div>';
        $('.sd_dropdown').html(tab_html);
      }

      proarray = [];

      const data = response.resources.results;

      // Articles tab
      if (data.articles.length > 0) {
        let appendToResult3 = '<div class="pagelist"><ul class="sd_dropdownresult_page">';
        $.each(data.articles, (index, articles) => {
          if (articles.title.toUpperCase().indexOf(searchstring) >= 0) {
            appendToResult3 += `<li id="${articles.id}"><a href="${articles.url}"><div class="sd_span"><div class="sd_title"> &#9679; ${articles.title}</div></div></a></li>`;
          }
        });

        appendToResult3 += `</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="${searchUrl(searchTerm, 'article')}">${footer_boxtext}</a></span></div></div>`;

        $(".tablinks4").click((e) => {
          e.preventDefault();
          setActiveTab('tablinks4');
          $('.sd_tabs').html(appendToResult3);
          pageHighlight(searchTerm);
        });
      } else {
        $(".tablinks4").click((e) => {
          e.preventDefault();
          setActiveTab('tablinks4');
          $('.sd_tabs').html(noResultHtml);
        });
      }

      // Pages tab
      if (data.pages.length > 0) {
        let appendToResult2 = '<div class="pagelist"><ul class="sd_dropdownresult_page">';
        $.each(data.pages, (index, pages) => {
          if (pages.title.toUpperCase().indexOf(searchstring) >= 0) {
            appendToResult2 += `<li id="${pages.id}"><a href="https://${hostname}/pages/${pages.handle}"><div class="sd_span"><div class="sd_title"> &#9679; ${pages.title}</div></div></a></li>`;
          }
        });

        appendToResult2 += `</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="${searchUrl(searchTerm, 'page')}">${footer_boxtext}</a></span></div></div>`;
        $(".tablinks3").click(() => {
          setActiveTab('tablinks3');
          $('.sd_tabs').html(appendToResult2);
          pageHighlight(searchTerm);
        });
      } else {
        $(".tablinks3").click(() => {
          setActiveTab('tablinks3');
          $('.sd_tabs').html(noResultHtml);
        });
      }

      // Collections tab
      if (data.collections.length > 0) {
        const proarray1 = [];
        let appendToResult1 = '<div class="collectionpanel"><ul class="sd_dropdownresult_collection">';
        $.each(data.collections, (index, collections) => {
          if (collections.title.toUpperCase().indexOf(searchstring) >= 0) {
            appendToResult1 += `<li id="${collections.id}"><a href="https://${hostname}/collections/${collections.handle}"><div class="sd_span"><div class="sd_title"> &#9679; ${collections.title}</div></div></a></li>`;
            proarray1.push({
              pid: collections.id,
              ptitel: collections.title,
              phandle: collections.handle,
            });
          }
        });

        appendToResult1 += `</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="https://${hostname}/collections">View All Collections</a></span></div></div>`;
        if (proarray1.length > 0) {
          $(".tablinks2").click(() => {
            setActiveTab('tablinks2');
            $('.sd_tabs').html(appendToResult1);
            colHighlight(searchTerm);
          });
        }
      } else {
        $(".tablinks2").click(() => {
          setActiveTab('tablinks2');
          $('.sd_tabs').html(noResultHtml);
        });
      }

      // Products tab
      if (data.products.length > 0) {
        let rows = '';
        $.each(data.products, (index, productsuggest) => {
          let imagesrc = '<div class="sd_searchimage"><img alt="Default Image" loading="lazy" class="sd_noimg prdimg" width="50px" src="https://storage.googleapis.com/binderpos-libraries/NoPicAvailable.png" /></div>';
          if (productsuggest.image != null) {
            imagesrc = `<div class="sd_searchimage"><img alt="Product Image" loading="lazy" class="prdimg" width="50px" src="${productsuggest.image}"></div>`;
          }

          const titleHtml = titleMatchesSearch(productsuggest.title, searchTerm) ?
            highlightMatchingTitle(productsuggest.title, searchTerm) :
            productsuggest.title;

          // Fixes 1 and 5: append in Shopify's order, with one consistent row layout.
          rows += `<li id="${productsuggest.id}">
                     <a href="https://${hostname}/products/${productsuggest.handle}">
                       ${imagesrc}
                       <div class="sd_span">
                         <div class="sd_title">${titleHtml}</div>
                         <div class="sd_price binder_predictiveSearch_price" style="color:${prccolor}!important;">
                           ${calculatePriceDisplay(productsuggest)}
                         </div>
                       </div>
                     </a>
                   </li>`;
          proarray.push({
            pid: productsuggest.id,
            ptitel: productsuggest.title,
            phandle: productsuggest.handle,
          });
        });

        const appendToResult = `<ul class="sd_dropdownresult">${rows}</ul><div class="sd_more_result"><span class="sd_show_all"><a class="showproduct" href="${searchUrl(searchTerm, 'product')}">${footer_boxtext}</a></span></div>`;

        if (proarray.length > 0) {
          $('.sd_tabs').html(appendToResult);
          setActiveTab('tablinks1');
        }

        $(".tablinks1").click(() => {
          setActiveTab('tablinks1');
          $('.sd_tabs').html(appendToResult);
        });
      } else {
        setActiveTab('tablinks1');
        $('.sd_tabs').html(noResultHtml);
        $(".tablinks1").click(() => {
          setActiveTab('tablinks1');
          $('.sd_tabs').html(noResultHtml);
        });
      }
    });
  }


  $(() => {
    $('.sd_product-search').css({position: 'relative', 'max-width': '280px'});
    $('.sd_dropdown').css({position: 'absolute', width: '100%', 'z-index': '999999', top: '29px'});
    $('.sd_product-search').fadeIn('fast');
    $('.sd_fixinner .sd_pro-search').css({'font-family': 'arial', height: '38px', margin: '0', padding: '5px', 'max-width': '100%', background: '#fff'});

    if ($(window).width() < 767) {
      $('.sd_fixinner .sd_product-search').css({margin: '0', 'max-width': '100%', 'font-family': 'arial', height: '38px', width: '88%', position: 'relative'});
    } else {
      $('.sd_fixinner .sd_product-search').css({margin: '0', 'max-width': '100%', 'font-family': 'arial', height: '38px', width: '90%', position: 'relative'});
    }

    const productTypeDDL = $('#sd_pro-product-type-ddl');

    const handleSearch = (searchVal) => {
      $('.sd_dropdown').show();

      if (globalTimeout != null) {
        clearTimeout(globalTimeout);
        globalTimeout = null;
      }

      if (searchVal.length > 1) {
        const typeFilter = (productTypeDDL && productTypeDDL.val() !== '' && productTypeDDL.val() !== undefined) ? productTypeDDL.val() : '';
        const searchQuery = typeFilter ? `product_type:${typeFilter} AND ${searchVal}` : searchVal;

        globalTimeout = setTimeout(() => handleFetchSearch(searchQuery, searchVal), 200);
      } else {
        // Invalidate any request still in flight so it can't redraw the cleared dropdown.
        latestRequestId++;
        $('.sd_dropdown').html(' ');
      }
    };

    if (productTypeDDL) {
      productTypeDDL.on('change', (event) => {
        event.target.closest('.search-bar__filter').querySelector('.search-bar__filter-active').innerText = event.target.options[event.target.selectedIndex].innerText;
        const searchVal = $(".sd_pro-search").val();
        handleSearch(searchVal);
      });
    }


    // fixed search start here
    $(".sd_pro-search").keyup(function(e) {
      const searchVal = $(this).val();
      handleSearch(searchVal);
    });
  });

  $(document).on('mouseenter', '.sd_dropdownresult li a', function() {
    $(this).css({background: 'rgb(242,242,242)'});
  });
  $(document).on('mouseleave', '.sd_dropdownresult li a', function() {
    $(this).css({background: '#fff'});
  });
  $(document).on('mouseenter', '.sd_dropdownresult_collection li a', function() {
    $(this).css({background: 'rgb(242,242,242)'});
  });
  $(document).on('mouseleave', '.sd_dropdownresult_collection li a', function() {
    $(this).css({background: '#fff'});
  });

})();
